import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';

import { IDialogDetails } from 'shared/types/purchaseTerm/purchaseTermsV2';

type TComponentPromo = IPromoModalProps['promo'];

export const preparePromo = (dialog: IDialogDetails): TComponentPromo => {
  return {
    authorName: dialog.formattedProviderName || '',
    authorLogo: dialog.providerLogo,
    name: dialog.promoName,
    features: dialog.promoProps.map(prop => ({
      name: prop.title,
      value: prop.value,
      valueChange: prop.valueChange,
      type: prop.type,
    })),
    banks: dialog.banks.map(bank => ({
      name: bank.name,
      logoUrl: bank.logo,
    })),
    description: dialog.promoDescription,
    availableJks: [],
    labels: dialog.labels,
    availablePurchaseTerms: [],
    mortgageLegalInfo: dialog.promoLegalTerms,
    cianMortgageButton: dialog.button,
    creditTerms: dialog.creditTerms,
    isBankMortgage: dialog.isBankMortgage,
  };
};
